import { Icon, Text } from '@leroy-merlin-br/backyard-react-ui'
import { ChevronRight } from '@leroy-merlin-br/backyard-react-icons'

import emitter from 'garden/src/js/utils/emitter'

import * as S from 'catalog/pages/Product/containers/Buybox/components/SellersListButton/styled'

const toggleDrawer = () => emitter.emit('buybox:drawer-open')

const SellersListButton = ({
  sellersListMinorPrice: price,
  sellersListUnit: unit
}) => (
  <S.Button type="button" onClick={toggleDrawer}>
    <Text size="kilo" noMargin>
      Mais opções a partir de{' '}
      <Text size="kilo" as="strong" noMargin bold>
        R$ {price} /{unit}
      </Text>
    </Text>

    <Icon as={ChevronRight} size="kilo" color="green" />
  </S.Button>
)

export default SellersListButton
